import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { TermsAndCondition } from '../../../cartAndOrders/orderInformation/components/TermsAndCondition'
import { getTerms } from '../../../cartAndOrders/store/thunk'
import { changeCheckRules, selectCheckRules, selectTerms } from '../store/slice'

export const TermsAndConditionPayment = () => {
  const dispatch = useDispatch()

  const locale = useSelector((state) => state.i18n.locale)
  const data = useSelector(selectTerms)

  useEffect(() => {
    if (!data) {
      dispatch(getTerms())
    }
  }, [locale])

  return (
    <TermsAndCondition
      changeCheckRules={changeCheckRules}
      selectCheckRules={selectCheckRules}
      selectTerms={selectTerms}
      appendStyleContainer={{ padding: 0 }}
    />
  )
}
